import {createFileRoute} from "@tanstack/react-router";
import {z as zod} from "zod";
import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {reportCollectionZodValidator} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportCollectionsWorkspaceCapability/domain/ReportCollection";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/collections/",
)({
    loader: async ({context}) => {
        const collectionsMetadataResult = await robustJsonResultClientFetch(
            `${context.intellsysBaseUrl}/sub-system/pluto/report-collections/get`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${context.authenticationStatus.accessToken}`,
                    "X-Workspace-Id": context.workspace.id,
                },
                body: JSON.stringify({}),
            },
            zod.array(reportCollectionZodValidator),
        );
        if (collectionsMetadataResult.success === false) {
            throw collectionsMetadataResult.error;
        }
        const collectionsMetadata = collectionsMetadataResult.data;

        return {
            workspace: context.workspace,
            collectionsMetadata,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
